import React, { useMemo } from "react"

import { Button } from "../../button"

import { ModalFooterContainer, ModalFooterSpecializedActionsContainer } from "./styles"
import { ModalFooterProps } from "./types"

export const ModalFooter: React.FC<ModalFooterProps> = ({
  size,
  className,
  children,
  isMobile,
  primaryButtonProps,
  secondaryButtonProps,
}) => {
  const primaryAction = useMemo(() => {
    return primaryButtonProps ? (
      <Button {...primaryButtonProps} fullWidth={isMobile} />
    ) : null
  }, [primaryButtonProps])

  const secondaryAction = useMemo(() => {
    return secondaryButtonProps ? (
      <Button {...secondaryButtonProps} variant="minor" fullWidth={isMobile} />
    ) : null
  }, [secondaryButtonProps])

  const specializedActions = useMemo(() => {
    return secondaryButtonProps || primaryButtonProps ? (
      <ModalFooterSpecializedActionsContainer size={size} isMobile={isMobile}>
        {secondaryAction}
        {primaryAction}
      </ModalFooterSpecializedActionsContainer>
    ) : null
  }, [primaryButtonProps, secondaryButtonProps, isMobile, size])

  return (
    <ModalFooterContainer size={size} isMobile={isMobile} className={className}>
      {children}
      {specializedActions}
    </ModalFooterContainer>
  )
}
